import { render, staticRenderFns } from "./mini-grid-count.vue?vue&type=template&id=08870ca4"
import script from "./mini-grid-count.vue?vue&type=script&lang=js"
export * from "./mini-grid-count.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports